import { API_BASE_URL } from './apiConfig';

const buildImageUrl = (path) => {
  const value = String(path || '').trim();
  if (!value) return '';

  if (
    value.startsWith('http://') ||
    value.startsWith('https://') ||
    value.startsWith('data:') ||
    value.startsWith('blob:')
  ) {
    return value;
  }

  let normalizedPath = value.replace(/^\/+/, '');

  // Soporta registros legacy donde se guardo solo el nombre del archivo de pregunta.
  if (!normalizedPath.includes('/') && /^image_question_\d+\./i.test(normalizedPath)) {
    normalizedPath = `uploads/preguntas/${normalizedPath}`;
  }

  const isLocalHost = typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname);

  if (isLocalHost) {
    return `http://localhost/diegoncurso/${normalizedPath}`;
  }

  const publicFilesBase = process.env.REACT_APP_PUBLIC_FILES_BASE_URL;
  if (publicFilesBase) {
    return `${publicFilesBase.replace(/\/$/, '')}/${normalizedPath}`;
  }

  const publicUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '');

  if (typeof window !== 'undefined' && window.location?.origin) {
    const basePrefix = publicUrl && publicUrl !== '/' ? `${publicUrl}/` : '/';
    return `${window.location.origin}${basePrefix}${normalizedPath}`;
  }

  if (publicUrl && publicUrl !== '/') {
    return `${publicUrl}/${normalizedPath}`;
  }

  return `/${normalizedPath}`;
};

export default buildImageUrl;

export const IMAGE_FALLBACK_SRC = '/media/images/default-fallback.png';

// Para el onError de <img>. Con React, e.target.onerror = null no desactiva el
// handler: si el propio fallback fallara, se reintentaría en bucle sin fin.
export const applyImageFallback = (e) => {
  if (e.target.getAttribute('src') === IMAGE_FALLBACK_SRC) return;
  e.target.src = IMAGE_FALLBACK_SRC;
};

// Para imágenes que ve cualquier visitante (ranking público): las URLs de
// terceros (CDN de Twitch, unavatar, Instagram...) se sirven por
// api/proxy_avatar.php, así el navegador del visitante no contacta con esos
// servicios ni les envía su IP (ver Política de privacidad / cookies).
const esHostPropio = (host) => {
  const h = String(host || '').toLowerCase();
  const actual = typeof window !== 'undefined' ? window.location.hostname : '';
  return h === actual || h === 'localhost' || h === '127.0.0.1'
    || h === 'diegoncurso.es' || h.endsWith('.diegoncurso.es');
};

export const buildProxiedImageUrl = (path) => {
  const value = String(path || '').trim();
  if (/^https?:\/\//i.test(value)) {
    let host = '';
    try { host = new URL(value).hostname; } catch (e) { return ''; }
    if (!esHostPropio(host)) {
      return `${API_BASE_URL}/proxy_avatar.php?url=${encodeURIComponent(value)}`;
    }
  }
  return buildImageUrl(value);
};
